module.exports = __webpack_public_path__ + "media/images/mock-thumbs/palms-banner-a14a6f6e6221bf723c9152d751208ea4.png";